import { PromoBannerType, TPromoBannerBase } from '@onesource/schemas';
import { FC } from 'react';

import { PromoBannerWithLaurenImage } from './banner-with-lauren';
import { PromoBannerCustom } from './promo-banner-custom';
import { PromoBannerDefault } from './promo-banner-default';
import { SidebarPromoBannerWithLaurenImage } from './sidebar-banner-with-lauren';

/**
 * How the structured (default) banner arranges its badge, copy and CTA:
 * `row` is the full-width card, `column` stacks them for a narrow slot such
 * as the community feed rail. The image and custom layouts size themselves.
 */
export type PromoBannerLayout = 'row' | 'column';

export interface PromoBannerProps {
  banner: TPromoBannerBase;
  layout?: PromoBannerLayout;
}

/**
 * Reusable, responsive promo banner. Dispatches to the layout configured by
 * `banner.type` (default | banner_with_lauren_image |
 * sidebar_banner_with_lauren_image | custom). Add a branch here to
 * introduce a new layout — callers keep using `<PromoBanner banner={...} />`
 * unchanged.
 */
export const PromoBanner: FC<PromoBannerProps> = ({ banner, layout = 'row' }) => {
  if (banner.type === PromoBannerType.BANNER_WITH_LAUREN_IMAGE) {
    return <PromoBannerWithLaurenImage banner={banner} />;
  }

  if (banner.type === PromoBannerType.SIDEBAR_BANNER_WITH_LAUREN_IMAGE) {
    return <SidebarPromoBannerWithLaurenImage banner={banner} />;
  }

  if (banner.type === PromoBannerType.CUSTOM) {
    return <PromoBannerCustom banner={banner} />;
  }

  return <PromoBannerDefault banner={banner} layout={layout} />;
};
